import React, { useState, useEffect, useRef, useContext } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import axios from "axios";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import sendRequest from "../utils/sendRequest";
import { checkAuth } from "../utils/checkAuth";
import Loader from "../components/Loader";
import swal from "sweetalert";
import { UserTypeContext } from "../MyContext";
import SecureLS from "secure-ls";
import { fundMap, fundObj1, fundObj2 } from "../utils/fundMap";
import { encrypt } from "../utils/cipher";
// import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: 40,
        borderRadius: 5,
        boxShadow: "0px 3px 15px #BCB0B0",
        background: " #EEEEEE",
        flexDirection: "column",

    },


    container: {
        display: "flex",

        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        height: "70%"
    },

}));
// const columns = [
//     { filed: "index", headerName: "Index", width: 250 },
//     { field: "AMC name", headerName: "AMC Name", width: 250 },


//     {
//         field: "Edit",
//         headerName: "Action",
//         width: 190,

//     },
// ];

const theme = createTheme();

const ManageUser = () => {
    const ls = new SecureLS();
    const cardStyles = useStyles(theme);
    const [state, setState] = useState([]);

    const [searchData, setSearchData] = useState("");

    const [loader, setLoader] = useState(false);

    const [isDownloading, setIsDownloading] = useState(false);

    let navigate = useNavigate();
    let fetchedData = useRef();
    const userType = ls.get("userType");

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setLoader(true);
        //  let authenticated = await checkAuth();
        //  if (!authenticated) navigate("/Login");
        //  else {
        let encryptedPayload = encrypt(userType)

        sendRequest('api/admin/getAllUserData', { payload: encryptedPayload }).then((response) => {
            fetchedData.current = response.data;
            // console.log("response lis", fetchedData.current);
            setState(fetchedData.current);
            setLoader(false);
        }).catch(error => {
            swal("Failed", error, "error");
            setLoader(false);
        });
        //  }
    };
    const handleDelete = (input) => {


        swal("Confirm the below details", "", {

            buttons: ["Cancel", "Delete"],
        }).then(result => {
            setLoader(true);
            if (result) {
                let encryptedPayload = encrypt(input.user.email)
                sendRequest("api/update/deleteUserDetails", { payload: encryptedPayload })
                    .then((response) => {
                        // console.log(response);
                        if (response.type === "success") {
                            fetchData();
                            swal("Done", "User is deleted", "success");
                            setLoader(false);
                            navigate("/Manageuser");

                        } else {
                            setLoader(false);
                            swal("", response.message, "error");
                        }
                    })
                    .catch((error) => {
                        swal("", "Something went wrong", "error");
                        setLoader(false);
                    });
            } else {
                setLoader(false);
            }

        });

    };

    //Function to download Excel sheet
    function downloadExcel(users) {
        // Format the data
        let csvContent = "Sr No.,SEBI Registration Number,Name of PMS,Mail ID\n" +
            users.map((user, idx) => `${idx + 1},${user.regno},${user.name},${user.email}`).join('\n');
        let blob = new Blob([csvContent], { type: 'text/csv' });
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = 'users.csv';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    //Triggers when download button is clicked
    const handleReportDownload = () => {
        try {
            setIsDownloading(true);
            const users = [];
            state.map((ele) => {
                users.push({ regno:ele.pmsCode, name: ele.pmsName, email: ele.user.email });
            });
            // console.log(users);
            downloadExcel(users);
            swal("Done", "List of Registered Portfolio Managers is downloaded", "success");
        }
        catch {
            swal("", "Something went wrong", "error");
        }
        finally {
            setIsDownloading(false);
        }
    }

    const handleSearch = (searchedVal) => {
        // console.log("search check :", searchedVal);
        setSearchData(searchedVal);

        // console.log("fetched dtaa :", fetchedData.current);
        if (state === "") {
            setState(fetchedData.current);
        }
        const filteredRows = fetchedData.current.filter((row) => {
            if (userType == "PMS") {
                return row.user.email.toLowerCase().includes(searchedVal.toLowerCase()) || row.pmsName.toLowerCase().includes(searchData.toLowerCase());
            }
            else if (userType == "APMII") {
                return row.user.email.toLowerCase().includes(searchedVal.toLowerCase()) || row.firstName.toLowerCase().includes(searchData.toLowerCase());;
            }
            else {
                return row.user.email.toLowerCase().includes(searchedVal.toLowerCase());
            }
        });
        // console.log(filteredRows);
        if (filteredRows.length === 0) {
        }
        setState(filteredRows);
    };

    return (
        <ThemeProvider theme={theme}>
            <Navbar />
            <Loader visible={loader} />
            <Container
                theme={theme.container}
                component="main"
                maxWidth="lg"
                sx={{
                    height: "70vh",
                    marginTop: "40px",
                    width: "80%",
                    flexDirection: "column",
                }}

            //className={}

            >
                <Box
                    sx={{
                        marginBottom: "15px",

                    }}
                >
                    <AppBar
                        position="static"
                        sx={{
                            height: "10%",
                            bgcolor: "#EEEEEE",
                        }}
                    >
                        <Toolbar
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "80%"
                            }}
                        >
                            <Box
                                sx={{
                                    color: "#255379",
                                    display: "flex",

                                    flexDirection: "row",
                                    height: "100%",
                                    width: "100%",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}
                            >

                                <span
                                    style={{
                                        bgcolor: "#255379",
                                        marginTop: "10px",
                                        fontSize: "large",
                                    }}
                                >
                                    {/* <ArrowDropDownIcon /> */}
                                </span>
                            </Box>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "center",
                                    width: "70%",
                                }}
                            >
                                <p
                                    style={{
                                        fontWeight: 550,
                                        marginBottom: "0px",
                                        color: "#153064",
                                        marginRight: "2rem"
                                    }}
                                >
                                    Search
                                </p>
                                <TextField
                                    id="outlined-basic"
                                    variant="outlined"
                                    size="small"
                                    value={searchData}
                                    onChange={(e) => {
                                        handleSearch(e.target.value);
                                    }}
                                    sx={{
                                        width: "90%",
                                        boxSizing: "border-box ",
                                        border: " 1px solid #CECECE",
                                        background: " #FFFFFF",
                                        marginBottom: "10px",
                                        marginTop: "0px",
                                        paddingTop: "0px",
                                    }}
                                />
                                {userType === "PMS" && <Button
                                    variant="contained"
                                    sx={{
                                        bgcolor: "#272782",
                                        width: "180px",
                                        height: "40px",
                                        marginLeft: "30px",
                                    }}
                                    onClick={handleReportDownload}
                                    // startIcon={<ArrowDownwardIcon />}
                                >
                                    {isDownloading ? 'DOWNLOADING...' : 'DOWNLOAD'}
                                </Button>}

                                {/* <Button
                                    onClick={handleAction}
                                    variant="contained"
                                    sx={{
                                        bgcolor: "#272782",
                                        width: "50px",
                                        height: "40px",
                                        marginLeft: "10px",
                                        color: "white",
                                        // "&:hover":{
                                        //     bgcolor:"#4A7497"
                                        // }

                                    }}
                                >
                                    GO
                                </Button> */}
                            </Box>
                        </Toolbar>
                    </AppBar>
                </Box>
                <Card
                    sx={{
                        marginTop: 5,
                        maxHeight: 400,
                        borderRadius: 1,
                        boxShadow: "0px 3px 15px #BCB0B0",
                        background: " #EEEEEE",
                        borderRadius: "20%",
                        border: "3px solid blue",
                        "&.MuiCard-root": {
                            overflow: "scroll !important"
                        }
                    }}

                    style={{ overflow: "scroll !important" }}
                >
                    <Box sx={{ width: "100%", overflow: "scroll", scrollbarWidth: "none" }}>
                        <TableContainer sx={{
                            maxHeight: {
                                md: 300,
                                lg: 300,
                                xl: 600,
                                xs: 600
                            },

                            minWidth: 850,
                            "&::-webkit-scrollbar": {
                                width: 5
                            },
                            "&::-webkit-scrollbar-track": {
                                backgroundColor: "transparent"
                            },
                            "&::-webkit-scrollbar-thumb": {
                                backgroundColor: "#999999",
                                borderRadius: 3
                            },


                            overflow: "scroll !important",

                        }}>
                            <Table sx={{ minWidth: 650, backgroundColor: "" }} stickyHeader aria-label="simple table">
                                <TableHead sx={{ backgroundColor: "#272782 !important" }} >
                                    <TableRow sx={{ backgroundColor: "#272782 !important" }}>
                                        {/* <TableCell align="center" sx={{ fontSize: "medium", color: "white" }}>Index</TableCell> */}
                                        <TableCell align="center" sx={{ fontSize: "medium", color: "white", backgroundColor: "#272782 !important" }}>Email</TableCell>
                                        <TableCell align="center" sx={{ fontSize: "medium", color: "white", backgroundColor: "#272782 !important" }}>{userType == "SEBI" ? "Division" : (userType == "PMS" ? "PMS Name" : "APMI Name")}</TableCell>
                                        <TableCell align="center" sx={{ fontSize: "medium", color: "white", backgroundColor: "#272782 !important" }}>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody >
                                    {state?.map((row, index) => (

                                        <TableRow
                                            key={row._id}
                                            sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                        >
                                            {/* <TableCell align="center">{row.user.email}</TableCell> */}
                                            <TableCell align="center" component="th" scope="row">
                                                {/* {userType == "SEBI" ? row.email : row.user.email} */}
                                                {row.user.email}
                                            </TableCell>

                                            {userType == "SEBI" ?

                                                <TableCell align="center" component="th" scope="row" style={{ overflowWrap: "anywhere", maxWidth: 200 }}>
                                                    {/* {row?.app !=undefined && console.log("Object.values(row?.app?.reports)",Object.keys(row?.app?.reports))}
                                                    { row?.app !=undefined &&  Object.keys(row?.app?.reports)?.map((ele, i) => {
                                                        console.log("ASDFDGFFDFDFD", ele+':'+row?.app?.reports[ele]);
                                                        return   "["+ ele+':'+"("+row?.app?.reports[ele]+")"+"]".split(")]")
                                                    }).join(" , ")} */}
                                                    {row.division}
                                                </TableCell> :
                                                <TableCell align="center" component="th" scope="row">
                                                    {userType == "APMII" ? row["firstName"] : row["pmsName"]}
                                                </TableCell>
                                            }
                                            <TableCell align="center" component="th" scope="row" >
                                                <Button
                                                    variant="contained"
                                                    sx={{
                                                        bgcolor: "#272782",
                                                        width: "86px",
                                                        height: "27px",
                                                        marginLeft: "6px"

                                                    }}
                                                    onClick={() => {
                                                        // console.log("Edit Clicked", row);
                                                        navigate(`/edituser`, { state: row });
                                                    }}
                                                >
                                                    Edit
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    sx={{
                                                        bgcolor: "#272782",
                                                        width: "86px",
                                                        height: "27px",
                                                        marginLeft: "10px"
                                                    }}
                                                    onClick={() => handleDelete(row)} >
                                                    DELETE
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Card>
            </Container>
        </ThemeProvider>
    );
};
export default ManageUser;